// extracted by mini-css-extract-plugin
module.exports = {"root":"Switch_root__3oIt4"};